import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import AssignmentsDetailPres from '../../presentational/AssignmentsDetail/AssignmentsDetailPres';
import {
  fetchAssignmentDetailHeaderApi,
  fetchAssignmentServicesApi,
  getAssignmentServicesApi,
  upsertAssignmentServicesApi,
  deleteAssignmentServicesApi,
} from 'src/services/assignments.service';
import { ASSIGNMENT_RELATED_ENTITIES } from 'src/constants/constants.js';
import { PageTitle } from 'src/ui/library/PageTitle';
import { withSnackbar } from 'notistack';
import { createTableColumns } from 'src/helpers';
import { getCurrency, getNumber } from 'src/helpers/currency';
import { formatDate } from 'src/helpers/date';

class AssignmentsDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      header: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    const { assignmentId } = this.props.match.params;

    this.setState({
      isLoading: true,
    });
    fetchAssignmentDetailHeaderApi(assignmentId).then(
      results => {
        if (results && !results.error && !results.errors) {
          const header = {
            employeeName: results.employeeName,
            hostCountry: results.hostCountry,
            homeCountry: results.homeCountry,
            policy: results.policy,
            openClosed: results.openClosed,
            endDate: results.endDate,
          };
          this.setState({
            header,
          });
        } else {
          let errorMsg = ' - ';
          if (results.error) {
            errorMsg += results.error.message;
          } else if (results.errors) {
            results.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.enqueueSnackbar('Failed to fetch header' + errorMsg, { variant: 'error' });
        }
        this.setState({
          isLoading: false,
        });
      },
      error => {
        this.props.enqueueSnackbar('Failed to fetch header - ' + error.message, { variant: 'error' });
        this.setState({
          isLoading: false,
        });
      },
    );
  }

  tabsHandler = (event, value) => {
    this.setState({
      tab: value,
    });
  };

  getPropsForRelatedEntities = entity => {
    let fetch,
      get,
      upsert,
      del = null;
    let isReformatCurrency = false;
    let relatedEntities = [];
    let sortColumn = '';
    let readOnly = false;
    let area = 'assignments';
    let onValidate = null;

    switch (entity) {
      case ASSIGNMENT_RELATED_ENTITIES.serviceInitServices:
        fetch = fetchAssignmentServicesApi;
        get = getAssignmentServicesApi;
        upsert = upsertAssignmentServicesApi;
        del = deleteAssignmentServicesApi;
        break;
      default:
        return;
    }

    return { fetch, get, upsert, del, isReformatCurrency, relatedEntities, sortColumn, readOnly, area, onValidate };
  };

  getTableColumnsForRelatedEntities = entity => {
    let allColumns,
      visibleColumns = [];
    let options = {};

    switch (entity) {
      case ASSIGNMENT_RELATED_ENTITIES.serviceInitServices:
        allColumns = ['id', 'name', 'createdOn'];
        visibleColumns = ['name', 'createdOn'];
        options = {
          createdOn: {
            renderComponent: value => {
              return formatDate(value);
            },
          },
        };
        break;
      default:
        return;
    }

    /* Create columns config object used in <Table /> */
    const columns = createTableColumns('assignments.' + entity, {
      columns: allColumns,
      visible: visibleColumns,
      options: options,
    });

    return columns;
  };

  encodeCurrencyData = (inData, isReformatCurrency, currencyString) => {
    if (isReformatCurrency) {
      inData.pageElements.forEach(x => {
        if (x.value && (x.displayText === 'Salary (Base)' || x.displayText === 'Salary')) {
          x.value = getCurrency(currencyString, x.value);
        }
      });
    }
    return inData;
  };

  decodeCurrencyData = (inData, isReformatCurrency) => {
    if (isReformatCurrency) {
      inData.pageElements.forEach(x => {
        if (x.value && (x.displayText === 'Salary (Base)' || x.displayText === 'Salary')) {
          x.value = getNumber(x.value);
        }
      });
    }
    return inData;
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title={intl.get('assignments.details.pageTitle')} />
        <AssignmentsDetailPres
          handleTabSelect={this.tabsHandler}
          tab={this.state.tab}
          getPropsForRelatedEntities={this.getPropsForRelatedEntities}
          getTableColumnsForRelatedEntities={this.getTableColumnsForRelatedEntities}
          decodeCurrencyData={this.decodeCurrencyData}
          encodeCurrencyData={this.encodeCurrencyData}
          {...this.state}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(AssignmentsDetailContainer));
